import SurveyView from "./view";
import SurveyShowController from "./control/show";
export default function SurveyScreen(element) {
  const view = SurveyView(element);
  const show = SurveyShowController(view);
  return Object.assign(view, {
    show
  });
}